import styles from './Infobox.module.scss';
import { motion } from 'framer-motion';
import Button from '../button/Button';
import { useState } from 'react';

function Infobox({
  label,
  content,
  showIcon,
}: {
  label?: string;
  showIcon?: boolean;
  content: React.ReactNode;
}) {
  const [show, setShow] = useState(false);

  return (
    <>
      <motion.div
        className={styles.InfoboxBackdrop}
        initial={{ opacity: 0 }}
        animate={{
          opacity: show ? 1 : 0,
        }}
        style={{ pointerEvents: show ? 'auto' : 'none' }}
        onClick={() => setShow(false)}
        transition={{ duration: 0.29, easings: 'easeInOut' }}
      />
      <div className={styles.Infobox}>
        {showIcon && (
          <div className={styles.InfoboxIcon} onClick={() => setShow(!show)}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="20" height="20" rx="10" fill="#E0E0E0" />
              <path
                d="M8.73 12.23V12.035C8.73 11.585 8.805 11.19 8.955 10.85C9.115 10.5 9.31 10.19 9.54 9.92C9.78 9.64 10.03 9.38 10.29 9.14C10.64 8.79 10.955 8.45 11.235 8.12C11.525 7.79 11.67 7.4 11.67 6.95C11.67 6.69 11.605 6.445 11.475 6.215C11.345 5.985 11.15 5.8 10.89 5.66C10.64 5.52 10.33 5.45 9.96 5.45C9.45 5.45 9.01 5.61 8.64 5.93C8.27 6.25 8.04 6.675 7.95 7.205L6.63 6.905C6.72 6.355 6.915 5.875 7.215 5.465C7.525 5.045 7.915 4.72 8.385 4.49C8.865 4.26 9.395 4.145 9.975 4.145C10.625 4.145 11.185 4.28 11.655 4.55C12.135 4.81 12.505 5.15 12.765 5.57C13.025 5.99 13.155 6.445 13.155 6.935C13.155 7.375 13.065 7.765 12.885 8.105C12.705 8.435 12.475 8.74 12.195 9.02C11.925 9.3 11.655 9.58 11.385 9.86C11.055 10.18 10.765 10.515 10.515 10.865C10.275 11.205 10.155 11.605 10.155 12.065V12.23H8.73ZM8.745 15.5V13.7H10.2V15.5H8.745Z"
                fill="#767676"
              />
            </svg>
          </div>
        )}
        {label && (
          <div className={styles.InfoboxTrigger} onClick={() => setShow(!show)}>
            {label}
          </div>
        )}
        <motion.div
          className={styles.InfoboxContent}
          initial={{ opacity: 0, transform: 'translateY(0)' }}
          animate={{
            transform: show ? 'translateY(-40%)' : 'translateY(0)',
            opacity: show ? 1 : 0,
          }}
          style={{ pointerEvents: show ? 'auto' : 'none' }}
          transition={{ duration: 0.29, easings: 'easeInOut' }}
          exit={{ opacity: 0, transform: 'translateY(0)' }}
          onClick={() => setShow(false)}
        >
          {content}
          <Button wide>Okay</Button>
        </motion.div>
      </div>
    </>
  );
}

export default Infobox;
